const userAgent = () => (typeof navigator === "undefined" ? "" : navigator.userAgent || "");

const firstMatch = (expression) => {
  const match = userAgent().match(expression);
  return match ? match[1] : "";
};

const browserDetails = () => {
  const agent = userAgent();
  if (/Edg\//.test(agent)) return ["Edge", firstMatch(/Edg\/([\d.]+)/)];
  if (/OPR\//.test(agent)) return ["Opera", firstMatch(/OPR\/([\d.]+)/)];
  if (/Firefox\//.test(agent)) return ["Firefox", firstMatch(/Firefox\/([\d.]+)/)];
  if (/Chrome\//.test(agent)) return ["Chrome", firstMatch(/Chrome\/([\d.]+)/)];
  if (/Safari\//.test(agent)) return ["Safari", firstMatch(/Version\/([\d.]+)/)];
  return ["", ""];
};

const operatingSystemDetails = () => {
  const agent = userAgent();
  if (/Windows NT/.test(agent)) return ["Windows", firstMatch(/Windows NT ([\d.]+)/)];
  if (/Android/.test(agent)) return ["Android", firstMatch(/Android ([\d.]+)/)];
  if (/iPhone|iPad|iPod/.test(agent)) return ["iOS", firstMatch(/OS ([\d_]+)/).replace(/_/g, ".")];
  if (/Mac OS X/.test(agent)) return ["macOS", firstMatch(/Mac OS X ([\d_]+)/).replace(/_/g, ".")];
  if (/Linux/.test(agent)) return ["Linux", ""];
  return ["", ""];
};

export const getDeviceInfo = () => {
  const [browser, browserVersion] = browserDetails();
  const [operatingSystem, operatingSystemVersion] = operatingSystemDetails();
  const browserNavigator = typeof navigator === "undefined" ? {} : navigator;

  return {
    browser,
    browserVersion,
    operatingSystem,
    operatingSystemVersion,
    cpu: browserNavigator.userAgentData?.platform || browserNavigator.platform || "",
    language: browserNavigator.language || "",
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
    cookiesEnabled: Boolean(browserNavigator.cookieEnabled),
  };
};

export const getDeviceHeaders = () => {
  const device = getDeviceInfo();
  return {
    "X-Client-Browser": device.browser,
    "X-Client-Browser-Version": device.browserVersion,
    "X-Client-OS": device.operatingSystem,
    "X-Client-OS-Version": device.operatingSystemVersion,
    "X-Client-CPU": device.cpu,
    "X-Client-Language": device.language,
    "X-Client-Timezone": device.timezone,
    "X-Client-Cookies-Enabled": String(device.cookiesEnabled),
  };
};
